

export default class BeoordeeldeTriageCriteriumAntwoord {

    public id: number;
    public omschrijving: string;
    public sortering: number;
}
